export default "__VITE_ASSET__gjVetF3C__"